import { render, staticRenderFns } from "./VideoDetail.vue?vue&type=template&id=4b11509a&scoped=true"
import script from "./VideoDetail.vue?vue&type=script&lang=js"
export * from "./VideoDetail.vue?vue&type=script&lang=js"
import style0 from "./VideoDetail.vue?vue&type=style&index=0&id=4b11509a&prod&lang=scss&scoped=true"
import style1 from "./VideoDetail.vue?vue&type=style&index=1&id=4b11509a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b11509a",
  null
  
)

export default component.exports